import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { installErrorReporting } from "./lib/errors";

installErrorReporting();

const SITE = process.env.REACT_APP_SITE_URL;
if (SITE && process.env.NODE_ENV === "production") {
  const canonicalHost = new URL(SITE).host;
  const { host, protocol, pathname, search, hash } = window.location;
  if (host === `www.${canonicalHost}` || (canonicalHost.startsWith("www.") && host === canonicalHost.slice(4))) {
    window.location.replace(`${protocol}//${canonicalHost}${pathname}${search}${hash}`);
  }
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);

const splash = document.getElementById("splash");
if (splash) setTimeout(() => { splash.style.opacity = "0"; setTimeout(() => splash.remove(), 400); }, 300);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").then((reg) => {
    const activate = () => reg.waiting?.postMessage({ type: "SKIP_WAITING" });
    activate();
    reg.addEventListener("updatefound", () => { const w = reg.installing; w?.addEventListener("statechange", () => { if (w.state === "installed") activate(); }); });
    reg.update().catch(() => {});
    setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
  }).catch(() => {}));
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => { if (refreshing) return; refreshing = true; window.location.reload(); });
}
